import { render, staticRenderFns } from "./ProductTypeEdit.vue?vue&type=template&id=c92a698e&scoped=true&"
import script from "./ProductTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ProductTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a698e",
  null
  
)

export default component.exports